import Login from "@/pages/auth/Login";
import Logout from "@/pages/auth/Logout";
import Unauthorized from "@/pages/auth/Unauthorized";
import AuthCallback from "@/components/AuthCallback.jsx";
import ADSelfService from "@/pages/public/ADSelfService";

export const publicRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/ad-users-self-service",
    element: <ADSelfService />,
  },
];
